import Page from '@app/components/layout/page/page';
import SoldFoodAndDrinkItemForm from '../components/item/sold-food-and-drink-item-form';
import { useSoldFoodAndDrinkItem } from '../sold-food-and-drink-item-context';

export default function SoldFoodAndDrinkItemPage() {
  const { item, status } = useSoldFoodAndDrinkItem();
  return (
    <Page name="Food and drink" page="subpage" status={status} flexFullHeight>
      <SoldFoodAndDrinkItemForm item={item} />
    </Page>
  );
}
